var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a, _b, _c;
import AjaxHelper from "../helper/AjaxHelper.js";
import CSSHelper from "../helper/CSSHelper.js";
import Fullscreen from "../helper/util/Fullscreen.js";
import Container from "./Container.js";
import DemoCodeEditor from "./DemoCodeEditor.js";
import Toolbar from "./Toolbar.js";
const _DemoHeader = class _DemoHeader extends Container {
  construct(...args) {
    super.construct(...args);
    this.setupToolbar();
  }
  static get titleLink() {
    const match = /(.*?\/)(examples.*?\/frameworks\/.*?)\/(build|out|dist)/.exec(document.location.href);
    return match ? `${match[1]}examples/#example-${match[2].replace(/\//gm, "-").replace("examples-frameworks", "frameworks")}` : "#";
  }
  async toggleCodeEditor() {
    this.codeEditor = await DemoCodeEditor.toggleCodeEditor(
      this.codeEditor,
      this.widgetMap.tools.widgetMap.codeButton,
      {
        appFolder: this.appFolder,
        preferredSources: [
          /App\.[jt]sx?/,
          /\w+Config\.[jt]sx?/,
          /index\.[jt]sx?/
        ]
      }
    );
  }
  async setupToolbar() {
    var _a2, _b2;
    const { location } = document, isTest = location.search.includes("test"), isDemoBrowser = location.href.match(/examples\/frameworks/);
    if (isDemoBrowser || isTest) {
      const demoProduct = ((_a2 = location.href.match(/\/(\w+)(-trial)?\/[-\w]*examples\//)) == null ? void 0 : _a2[1].toLowerCase()) || "grid", { widgetMap } = this.widgetMap.tools, {
        downloadButton,
        trialButton
      } = widgetMap;
      Object.values(widgetMap).forEach((widget) => widget.hidden = false);
      trialButton.href = `https://bryntum.com/download/?product=${demoProduct}`;
      const appConfig = (_b2 = await AjaxHelper.get(`${this.appFolder}/app.config.json`, { parseJson: true }).catch(() => {
      })) == null ? void 0 : _b2.parsedJson;
      if ((appConfig == null ? void 0 : appConfig.zip) || isTest) {
        downloadButton.href = `${this.appFolder}${appConfig.zip}`;
      } else {
        downloadButton.hidden = true;
      }
      CSSHelper.insertRule("body { flex-direction : row !important }");
      CSSHelper.insertRule("#container { flex: 1 !important; overflow : hidden !important }");
    }
  }
};
__publicField(_DemoHeader, "$name", "DemoHeader");
__publicField(_DemoHeader, "type", "demoheader");
__publicField(_DemoHeader, "configurable", {
  /**
   * The ID of the owner div element, which will have a header as first child
   * @config {String}
   */
  insertFirst: "container",
  /**
   * The path to the application folder to show code viewer
   * @config {String}
   */
  appFolder: "../",
  cls: "demo-header",
  items: [
    {
      type: "container",
      id: "title-container",
      items: [{
        type: "container",
        tag: "a",
        id: "title",
        elementAttributes: {
          href: _DemoHeader.titleLink
        },
        items: [{
          html: ((_a = document.title) != null ? _a : "Demo").split("-").pop().trim(),
          tag: "h1",
          tooltip: (_c = (_b = document.querySelector('meta[name="description"]')) == null ? void 0 : _b.content) != null ? _c : ""
        }]
      }]
    },
    {
      type: Toolbar.type,
      id: "tools",
      style: {
        border: "none",
        height: "2.8em"
      },
      defaults: {
        style: {
          margin: 0
        },
        cls: "b-raised b-blue"
      },
      items: [
        "->",
        {
          ref: "trialButton",
          type: "button",
          text: "Download Trial",
          cls: "b-green b-raised",
          href: "#",
          hidden: true
        },
        {
          ref: "codeButton",
          type: "button",
          tooltip: "Click to show the code viewer",
          icon: "b-icon-code",
          onClick: "up.toggleCodeEditor",
          hidden: true
        },
        {
          ref: "downloadButton",
          type: "button",
          tooltip: "Download this demo zip archive",
          icon: "b-icon-download",
          href: "#",
          hidden: true
        },
        {
          ref: "fullscreenButton",
          type: "button",
          tooltip: "Full screen",
          icon: "b-icon-fullscreen",
          onClick() {
            if (Fullscreen.enabled) {
              if (!Fullscreen.isFullscreen) {
                Fullscreen.request(document.body);
              } else {
                Fullscreen.exit();
              }
            }
          }
        }
      ]
    }
  ]
});
let DemoHeader = _DemoHeader;
DemoHeader._$name = "DemoHeader";
export {
  DemoHeader as default
};
